<template>
  <div class="bg-white min-h-screen flex flex-col">
    <RenderTemplateHeader />

    <main class="flex-1">
      <RenderTemplateBreadcrumb />
      <slot />
    </main>

    <RenderTemplateFooter class="z-0" />
  </div>
</template>

<script setup lang="ts">
import { useTemplateDataComposable } from '~/modules/template/composables/useTemplateDataComposable'
await useTemplateDataComposable({
  template: 'standard',
})
</script>
